import './side-panel.scss';

import PropTypes from 'prop-types';
import React from 'react';
import { createPortal } from 'react-dom';

const SidePanel = ({ title, cursiveTitle, onClose, children }) =>
  createPortal(
    <div
      role="presentation"
      className="side-panel-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
      onKeyDown={(e) => {
        if (e.key === 'Escape') onClose();
      }}>
      <div className="side-panel">
        <div className="side-panel__header">
          <button type="button" className="side-panel__back-link" onClick={onClose}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M19 12H5M12 19l-7-7 7-7"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Back
          </button>
          <h2 className="side-panel__title">
            {title} <span className="text-cursive">{cursiveTitle}</span>
          </h2>
          <button
            type="button"
            className="side-panel__close"
            onClick={onClose}
            aria-label="Close panel">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path
                d="M18 6L6 18M6 6l12 12"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>
        </div>
        {children}
      </div>
    </div>,
    document.body
  );

SidePanel.propTypes = {
  title: PropTypes.string.isRequired,
  cursiveTitle: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
};

export { SidePanel };
